import {HttpClient} from "../../service/httpClient/HttpClient";

export class TourismReportService {

    constructor() {
        this.httpClient = new HttpClient()
    }


    getCategoryReport(lang) {
        return this.httpClient.getFile(
                `languages/${1}/location-categories/meta-data/reports/XLSX`
            )
    }

    getTourismListReport = (langId) => {
        return this.httpClient.getFile(
                `languages/${1}/locations/meta-data/reports/XLSX`
            )
    }
}